module.exports = ".ck-content code{background-color:hsla(0,0%,78%,.3);padding:.15em;border-radius:2px}"